import React, {PropTypes} from 'react'
import {Link, browserHistory} from 'react-router'
import {Col, Row, Image, Carousel, Glyphicon} from 'react-bootstrap'
import {IoPlus} from '../Common/ReactIcons/icons'
import {Actions} from 'jumpstate'
import {chunk} from 'lodash'

const horseAvatar = `${window.location.protocol}//${window.location.host}/horse.jpg`

class HorseChildren extends React.Component {
  constructor (props) {
    super(props)
    this.goToNewHorse = this.goToNewHorse.bind(this)
  }
  goToNewHorse () {
    Actions.clearNewHorse()
    if (this.props.horse.genderType === 'male') {
      Actions.setNewHorseDetails({
        sire: {
          id: this.props.horse.id,
          name: this.props.horse.name,
          avatar: this.props.horse.avatar,
          strain: this.props.horse.strain
        }
      })
    } else {
      Actions.setNewHorseDetails({
        dam: {
          id: this.props.horse.id,
          name: this.props.horse.name,
          avatar: this.props.horse.avatar,
          strain: this.props.horse.strain
        },
        strain: this.props.horse.strain
      })
    }
    browserHistory.push('/new-horse')
  }
  render () {
    const allChild = chunk(this.props.children, 4)
    return (
      <Row className="Box Child">
        <Col xs={2} xsOffset={1}>
          <a onClick={this.goToNewHorse} className="AddChild">
            <IoPlus />
            <h5 className="Name">ثبت</h5>
            <h6 className="Strain">فرزند جدید</h6>
          </a>
        </Col>
        <Col xs={8}>
          <Carousel controls interval={10000000000} className={this.props.children.length < 5 && 'HideControl'} nextIcon={<Glyphicon glyph="chevron-right" />} >

            {allChild.map((children, index) => {
              return (
                <Carousel.Item key={index}>
                  {children.map((child, i) => {
                    return (
                      <Col xs={3} key={i}>
                        <Link to={`/horse/${child.key}`}><Image src={(child.avatar) ? child.avatar : horseAvatar} alt="" className="Avatar" /></Link>
                        <h5 className="Name"><Link to={`/horse/${child.key}`}>{child.name}</Link></h5>
                        <h6 className="Strain">{child.strain !== null ? child.strain : '(نامشخص)'}</h6>
                      </Col>
                    )
                  })}
                </Carousel.Item>
              )
            }
          )}
          </Carousel>
        </Col>
      </Row>
    )
  }
}

HorseChildren.propTypes = {
  children: PropTypes.array.isRequired,
  horse: PropTypes.object.isRequired
}

export default HorseChildren



// WEBPACK FOOTER //
// ./src/components/HorseInfo/HorseChildren.js